import Button from "../components/button";

const NotFound = () => {
  return (
    <main className="flex h-[calc(100vh-95px)] w-full flex-col items-center justify-center">
      <h1 className="text-7xl font-bold text-visBlue text-opacity-10">404</h1>
      <p className="mb-4 mt-1">Sorry, we couldn't find that page.</p>
      <Button href={'/home'}>
        <span className="px-10">Navigate to Home Page</span>
      </Button>
    </main>
  );
};

export default NotFound;
